import cs from 'classnames';
import { useEffect, useMemo } from 'react';
import type { IAccordionItem } from '@/DesignSystem/Model/DataModel';
import { IconAngleDownCircle } from '@/Module/Icon';
import { getFAQListByTypeIdAction } from '@/Module/Question/Store/Action';
import { faqSelectAll } from '@/Module/Question/Store/Selector';
import { FAQTypeIdAction } from '@/Module/Question/Store/Slice/FAQSlice';
import { useAppDispatch, useAppSelector } from '@/Module/Store/Hook';
export const useSubscriptionFAQ = () => {
  const dispatch = useAppDispatch();
  const {
    isLoading
  } = useAppSelector(state => state.faq);
  const faqList = useAppSelector(faqSelectAll);
  const id = 6;
  const preparedData: IAccordionItem[] = useMemo(() => {
    return faqList.slice(0, 6).map(item => ({
      id: item.id,
      header: <div className="flex   items-center justify-between bg-white sm:cursor-pointer ">
          <span className={cs('inline-flex flex-1 px-6 py-4 text-blueFive text-sm sm:text-md md:text-lg font-semibold', 'group-[.ui--is-open]:text-blueFive transition-all duration-300')}>
            {item.question}
          </span>
          <IconAngleDownCircle className={cs('text-blueFive transition-all duration-300 sm:ml-2 ease-in-out rotate-180 group-[.ui--is-open]:rotate-0', 'group-[.ui--is-open]:text-blueFive')} />
        </div>,
      children: <p className=" bg-white px-6 pb-6 font-pelak text-sm leading-[30px] text-blackFive sm:pt-3 sm:text-base  lg:tracking-wide">
          {item.answer}
        </p>
    }));
  }, [faqList]);
  useEffect(() => {
    dispatch(FAQTypeIdAction(id));
    const promise = dispatch(getFAQListByTypeIdAction());
    return () => {
      promise.abort();
    };
  }, [id]);
  return {
    preparedData,
    isLoading
  };
};